/* eslint-disable global-require */
const { REACT_APP_URL } = process.env;

module.exports = {
  accountingSoftware: [
    {
      ids: ['sage'],
      name: 'Sage',
      url: `${REACT_APP_URL}/connect/sage`,
    },
    {
      ids: ['quickbooks', 'quickbooks online', 'quickbooksonline'],
      name: 'QuickBooks Online',
      url: `${REACT_APP_URL}/connect/qbo`,
    },
    {
      ids: ['xero'],
      name: 'Xero',
      url: `${REACT_APP_URL}/connect/xero`,
    },
    {
      ids: ['freeagent'],
      name: 'FreeAgent',
      url: `${REACT_APP_URL}/connect/freeagent`,
    },
    {
      ids: ['freshbooks'],
      name: 'FreshBooks',
      url: `${REACT_APP_URL}/connect/freshbooks`,
    },
    {
      ids: ['myobaccountright'],
      name: 'MYOB',
      url: `${REACT_APP_URL}/connect/myobaccountright`,
    },
    {
      ids: ['accountsiq'],
      name: 'AccountsIQ',
      url: `${REACT_APP_URL}/connect/`,
    },
    {
      ids: ['csv'],
      name: 'CSV',
      url: `${REACT_APP_URL}/connect/`,
    },
    {
      ids: ['dynamics365businesscentral'],
      name: 'Dynamics 365 Business Central',
      url: `${REACT_APP_URL}/connect/`,
    },
    {
      ids: ['sage200cloud'],
      name: 'Sage 200 Cloud',
      url: `${REACT_APP_URL}/connect/`,
    },
    {
      ids: ['zohobooks'],
      name: 'Zoho Books',
      url: `${REACT_APP_URL}/connect/`,
    },
    {
      ids: ['openapi'],
      name: 'Open API',
      url: `${REACT_APP_URL}/connect/`,
    },
    {
      ids: ['sage50'],
      name: 'Sage 50',
      url: `${REACT_APP_URL}/connect/`,
    },
    {
      ids: ['sage200'],
      name: 'Sage 200',
      url: `${REACT_APP_URL}/connect/`,
    },
    {
      ids: ['d365bc'],
      name: 'Dynamics 365 Business Central',
      url: `${REACT_APP_URL}/connect/`,
    },
    {
      ids: ['netsuite'],
      name: 'Netsuite',
      url: `${REACT_APP_URL}/connect/`,
    },
    {
      ids: ['odoo'],
      name: 'Odoo',
      url: `${REACT_APP_URL}/connect/`,
    },
    {
      ids: ['sageintacct'],
      name: 'Sage Intacct',
      url: `${REACT_APP_URL}/connect/`,
    },
  ],
  mpKey: '5ea67cead72fa013f4c1664ff880c1ba',
  webAppUrl: 'https://my.chaserhq.com',
  host: 'https://next-hub-api.chaserhq.com',
  admin: 'https://hub-old.chaserhq.com/admin',
  helpCentre: 'https://help.chaserhq.com/',
};
